import { ca } from '@cian/analytics';

import { BASE_EVENT } from '../../../tracking';

export const trackBuilderObjectsLinkClick = () =>
  ca('event', {
    ...BASE_EVENT,
    action: 'goto_listing_from_developer',
    label: 'Objects',
  });

export const trackAllObjectsLinkClick = () =>
  ca('event', {
    ...BASE_EVENT,
    action: 'goto_listing_all_objects',
    label: 'Objects',
  });
